import React from 'react';

import LazyImage from '../../../components/LazyImage';

import kkmmLogo from "../../../images/brands/kkmm-grey-logo.png";
import mdecLogo from "../../../images/brands/mdec-grey-logo.png";
import nexeaLogo from "../../../images/brands/nexea-grey-logo.png";
import wtfLogo from "../../../images/brands/wtf-grey-logo.png";
import cradleLogo from "../../../images/brands/cradle-grey-logo.png";
import pitchinLogo from "../../../images/brands/pitchin-grey-logo.png";

const brandsList = [
  {
    image: kkmmLogo,
    alt: "kkm-logo"
  },
  {
    image: mdecLogo,
    alt: "mdec-logo"
  },
  {
    image: nexeaLogo,
    alt: "nexea-logo"
  },
  {
    image: wtfLogo,
    alt: "wtf-logo"
  },
  {
    image: cradleLogo,
    alt: "cradle-logo"
  },
  {
    image: pitchinLogo,
    alt: "pitchin-logo"
  },
]

const BrandBanner = () => {
  return (
    <div className="w-full bg-[#F7F7F7] p-[25px] md:py-[50px] md:px-[70px] lg:py-[30px] lg:px-[150px] xl:px-[250px] 2xl:px-[350px]">
      <div className="flex flex-row flex-wrap justify-center py-[10px] md:py-[0px]">
        {brandsList.map((brand, index) => (
          <LazyImage className="h-[50px] w-[120px] mx-[15px] my-[10px] object-contain" src={brand.image} alt={brand.alt} key={`brand-${index}`} />
        ))}
      </div>
    </div>
  )
}

export default BrandBanner;